import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _22mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"22mp"} ref={ref}/>
});

_22mpIcon.displayName = "_22mpIcon";
